import { render, staticRenderFns } from "./LeaveApprovalDetails.vue?vue&type=template&id=4d10bd96&scoped=true&"
import script from "./LeaveApprovalDetails.vue?vue&type=script&lang=js&"
export * from "./LeaveApprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeaveApprovalDetails.vue?vue&type=style&index=0&id=4d10bd96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10bd96",
  null
  
)

export default component.exports